const ALICANTE_COVER = "/images/alicante.jpg";

export const ALICANTE_LISTOPAD_HR_DETAILED_INFO = `🌴 ALICANTE – ESCAPADA DE PRIMAVERA – SPRING ESCAPE
Proljetni bijeg na Costa Blancu – vino, more i radionica paelle

📅 01.10. – 04.10.
🗓 4 dana / 3 noći

Zamislite grad u kojem palmama okružena šetnica vodi do zlatnih plaža, gdje se povijesni dvorac uzdiže iznad grada, a miris svježe pripremljene paelle širi uskim ulicama starog grada.

Alicante, smješten na obali Costa Blance, jedan je od najsunčanijih gradova Španjolske. Grad spaja bogatu povijest, mediteranski način života, prekrasne plaže i izvrsnu gastronomiju. Uz živopisne tržnice, šarmantne kvartove i opuštenu atmosferu, Alicante je savršena destinacija za kratko, ali nezaboravno putovanje.

🍂 Zašto posjetiti Alicante u listopadu?
Rana jesen idealno je vrijeme za posjet ovom mediteranskom gradu.
• Ugodna klima – temperature oko 20–24°C savršene su za istraživanje grada.
• Manje gužve nego u ljetnim mjesecima – grad se može doživjeti opuštenije.
• Savršeno vrijeme za gastronomiju i vinske rute.
• Idealno za šetnje uz more, razgledavanje i izlete brodom.

Jesen u Alicanteu donosi sunce, miris mora i autentičnu španjolsku atmosferu – idealan bijeg prije zimskih dana.

💰 CIJENA PAKET ARANŽMANA FIRST MINUTE do 01.08.2026.
690,00 € po osobi
(da bi se putovanje ostvarilo potrebno je minimalno 8 osoba)

💰 CIJENA PAKET ARANŽMANA LAST MINUTE od 01.08.2026.
790,00 € po osobi
(da bi se putovanje ostvarilo potrebno je minimalno 8 osoba)

✅ CIJENA UKLJUČUJE
• Direktne jutarnje letove Ryanair Zagreb–Alicante–Zagreb
• Ručna prtljaga 40×20×25 cm uključena u cijenu
• Smještaj u privatnim, moderno opremljenim apartmanima u blizini centra grada
• Transfer aerodrom – smještaj – aerodrom
• Radionica pripreme tradicionalne španjolske paelle
• Posjet dvorcu Santa Bárbara uz mogućnost degustacije vina
• Organizirana šetnja gradom i upoznavanje s glavnim znamenitostima

❌ CIJENA NE UKLJUČUJE
• Carry-on prtljaga – mogućnost nadoplate za mali kofer u kabini
• Putno zdravstveno osiguranje i osiguranje od otkaza (moguće uz nadoplatu)
• Dodatne aktivnosti i izleti koji nisu navedeni u programu (npr. izlet na otok Tabarca, muzeji, Flamenco i sl.)
• Doručak nije uključen u cijenu apartmana; ručkovi i večere u vlastitom aranžmanu

📍 PROGRAM PUTOVANJA

1. DAN – 01.10. – Dolazak u Alicante
Nalazimo se u zračnoj luci Franjo Tuđman. Ranojutarnji direktan let za Alicante. Po dolasku transfer do moderno opremljenih apartmana u blizini centra grada. Popodne upoznavanje s gradom: Explanada de España, luka Alicante i marina, plaža Postiguet. Slobodno vrijeme za večeru i tapas barove.

2. DAN – 02.10. – Dvorac, vino i španjolska kuhinja
Doručak churros i topla čokolada. Posjet dvorcu Santa Bárbara – razgled i mogućnost degustacije lokalnih vina. Popodne radionica pripreme tradicionalne paelle. Večer slobodna.

3. DAN – 03.10. – Mediteranski ritam grada
Mercado Central, Calle de las Setas, Barrio Santa Cruz, MARQ (Arheološki muzej Alicantea). Popodne slobodno za kupanje ili šetnju. Opcionalno: izlet brodom na otok Tabarca (uz doplatu). Večer slobodna.

4. DAN – 04.10. – Povratak u Zagreb
Transfer u ranim jutarnjim satima. Direktan jutarnji let za Zagreb. Dolazak u prijepodnevnim satima.

🏛 NAJPOZNATIJE ZNAMENITOSTI ALICANTEA
Dvorac Santa Bárbara • Explanada de España • Mercado Central • Barrio Santa Cruz • Calle de las Setas • Plaža Postiguet • Luka Alicante • Otok Tabarca

💳 UVJETI PLAĆANJA
Za potvrdu rezervacije potrebno je uplatiti akontaciju u iznosu od 40% ukupne cijene aranžmana po osobi na broj računa HR7523400093207336956. Preostali iznos najkasnije 10 dana prije polaska. U slučaju neplaćanja preostalog iznosa u navedenom roku, organizator zadržava pravo otkazivanja rezervacije.

NAPOMENA: raspored programa po danima promjenjiv je do 2 tjedna prije puta, dok ne dobijemo termine za odgovarajuće aktivnosti.

📞 Rezervacije i informacije
Email: info@linatravelina.eu | Telefon: +385 91 214 4477

TraveLina – putovanja koja se pamte!`;

export const ALICANTE_LISTOPAD_EN_DETAILED_INFO = `🌴 ALICANTE – ESCAPADA DE PRIMAVERA – SPRING ESCAPE
Spring escape to the Costa Blanca – wine, sea and paella workshop

📅 1–4 October
🗓 4 days / 3 nights

Imagine a city where a palm-lined promenade leads to golden beaches, a historic castle rises above the rooftops, and the scent of freshly prepared paella drifts through the old town alleys.

Alicante, on the Costa Blanca, is one of Spain's sunniest cities. The city combines rich history, Mediterranean lifestyle, beautiful beaches and excellent gastronomy. With lively markets, charming neighbourhoods and a relaxed atmosphere, Alicante is the perfect destination for a short but unforgettable trip.

🍂 Why visit Alicante in October?
Early autumn is the ideal time to visit this Mediterranean city.
• Pleasant climate – temperatures around 20–24°C, perfect for exploring the city.
• Fewer crowds than in summer – a more relaxed experience.
• Perfect time for gastronomy and wine routes.
• Ideal for coastal walks, sightseeing and boat trips.

Autumn in Alicante brings sunshine, the scent of the sea and authentic Spanish atmosphere – an ideal escape before winter.

💰 PACKAGE PRICE FIRST MINUTE until 1 August 2026
€690.00 per person
(minimum 8 people required for the trip to take place)

💰 PACKAGE PRICE LAST MINUTE from 1 August 2026
€790.00 per person
(minimum 8 people required for the trip to take place)

✅ PRICE INCLUDES
• Ryanair morning flights Zagreb–Alicante–Zagreb
• Hand luggage 40×20×25 cm included in the price
• Accommodation in private, modern apartments near the city centre
• Airport–accommodation–airport transfers
• Traditional Spanish paella preparation workshop
• Visit to Santa Bárbara Castle with optional wine tasting
• Organised city walk and introduction to the main sights

❌ NOT INCLUDED
• Carry-on luggage – supplement available for a small cabin bag
• Travel and cancellation insurance (available at extra cost)
• Additional activities and excursions not listed in the programme (e.g. boat trip to Tabarca Island, museums, flamenco, etc.)
• Breakfast not included in the apartment price; lunches and dinners at own arrangement

📍 TRAVEL PROGRAMME

DAY 1 – 1 October – Arrival in Alicante
We meet at Franjo Tuđman Airport. Early morning direct flight to Alicante. On arrival, transfer to modern apartments near the city centre. Afternoon introduction to the city: Explanada de España, Alicante port and marina, Postiguet beach. Free time for dinner and tapas bars.

DAY 2 – 2 October – Castle, wine and Spanish cuisine
Breakfast of churros and hot chocolate. Visit to Santa Bárbara Castle – tour and optional tasting of local wines. Afternoon traditional paella workshop. Free evening.

DAY 3 – 3 October – Mediterranean rhythm of the city
Mercado Central, Calle de las Setas, Barrio Santa Cruz, MARQ (Alicante Archaeological Museum). Free afternoon for swimming or a walk. Optional: boat trip to Tabarca Island (supplement). Free evening.

DAY 4 – 4 October – Return to Zagreb
Early morning transfer to Alicante Airport. Direct morning flight to Zagreb. Arrival in Zagreb in the late morning.

🏛 TOP SIGHTS OF ALICANTE
Santa Bárbara Castle • Explanada de España • Mercado Central • Barrio Santa Cruz • Calle de las Setas • Postiguet beach • Alicante port • Tabarca Island

💳 PAYMENT TERMS
To confirm your booking, a deposit of 40% of the total package price per person is required to account HR7523400093207336956. The remaining balance is due at least 10 days before departure. If the balance is not paid within the stated period, the organiser reserves the right to cancel the booking.

NOTE: the daily programme schedule may change up to 2 weeks before the trip, until we receive confirmed times for the relevant activities.

📞 Bookings and information
Email: info@linatravelina.eu | Phone: +385 91 214 4477

TraveLina – trips you'll remember!`;

export const ALICANTE_LISTOPAD_DE_DETAILED_INFO = `🌴 ALICANTE – ESCAPADA DE PRIMAVERA – SPRING ESCAPE
Herbstausflug an die Costa Blanca – Wein, Meer und Paella-Workshop

📅 1.–4. Oktober
🗓 4 Tage / 3 Nächte

Stellen Sie sich eine Stadt vor, in der eine von Palmen gesäumte Promenade zu goldenen Stränden führt, eine historische Burg über den Dächern thront und der Duft frisch zubereiteter Paella durch die Gassen der Altstadt zieht.

Alicante an der Costa Blanca ist eine der sonnigsten Städte Spaniens. Die Stadt verbindet reiche Geschichte, mediterranen Lebensstil, wunderschöne Strände und ausgezeichnete Gastronomie. Mit lebhaften Märkten, charmanten Vierteln und entspannter Atmosphäre ist Alicante das perfekte Ziel für eine kurze, aber unvergessliche Reise.

🍂 Warum Alicante im Oktober besuchen?
Der frühe Herbst ist die ideale Zeit für diesen mediterranen Ort.
• Angenehmes Klima – Temperaturen um 20–24°C, ideal zum Erkunden der Stadt.
• Weniger Andrang als im Sommer – entspannteres Erlebnis.
• Perfekte Zeit für Gastronomie und Weinrouten.
• Ideal für Spaziergänge am Meer, Sightseeing und Bootsausflüge.

Der Herbst in Alicante bringt Sonne, Meeresduft und authentische spanische Atmosphäre – ein idealer Kurzurlaub vor dem Winter.

💰 PAKETPREIS FIRST MINUTE bis 1. August 2026
690,00 € pro Person
(mindestens 8 Personen für die Durchführung der Reise erforderlich)

💰 PAKETPREIS LAST MINUTE ab 1. August 2026
790,00 € pro Person
(mindestens 8 Personen für die Durchführung der Reise erforderlich)

✅ PREIS INKLUSIVE
• Ryanair-Morgenflüge Zagreb–Alicante–Zagreb
• Handgepäck 40×20×25 cm im Preis inbegriffen
• Unterkunft in privaten, modern ausgestatteten Apartments nahe dem Stadtzentrum
• Transfer Flughafen – Unterkunft – Flughafen
• Workshop zur Zubereitung traditioneller spanischer Paella
• Besuch der Burg Santa Bárbara mit optionaler Weinverkostung
• Organisierte Stadtführung und Kennenlernen der Hauptsehenswürdigkeiten

❌ NICHT INKLUSIVE
• Carry-on-Gepäck – Aufpreis für kleinen Kabinenkoffer möglich
• Reise- und Stornoversicherung (gegen Aufpreis)
• Zusätzliche Aktivitäten und Ausflüge, die nicht im Programm stehen (z. B. Bootsausflug nach Tabarca, Museen, Flamenco usw.)
• Frühstück nicht im Apartmentpreis enthalten; Mittag- und Abendessen eigenständig

📍 REISEPROGRAMM

TAG 1 – 1. Oktober – Ankunft in Alicante
Treffen am Flughafen Franjo Tuđman. Frühmorgendlicher Direktflug nach Alicante. Nach der Ankunft Transfer zu modernen Apartments nahe dem Stadtzentrum. Nachmittags Stadtführung: Explanada de España, Hafen und Marina von Alicante, Strand Postiguet. Freie Zeit für Abendessen und Tapas-Bars.

TAG 2 – 2. Oktober – Burg, Wein und spanische Küche
Frühstück mit Churros und heißer Schokolade. Besuch der Burg Santa Bárbara – Besichtigung und optionale Verkostung lokaler Weine. Nachmittags Workshop zur Zubereitung traditioneller Paella. Freier Abend.

TAG 3 – 3. Oktober – Mediterraner Rhythmus der Stadt
Mercado Central, Calle de las Setas, Barrio Santa Cruz, MARQ (Archäologisches Museum Alicante). Freier Nachmittag zum Baden oder Spazierengehen. Optional: Bootsausflug zur Insel Tabarca (gegen Aufpreis). Freier Abend.

TAG 4 – 4. Oktober – Rückkehr nach Zagreb
Frühmorgendlicher Transfer zum Flughafen Alicante. Direktflug am Morgen nach Zagreb. Ankunft in Zagreb am Vormittag.

🏛 BEKANNTESTE SEHENSWÜRDIGKEITEN ALICANTES
Burg Santa Bárbara • Explanada de España • Mercado Central • Barrio Santa Cruz • Calle de las Setas • Strand Postiguet • Hafen Alicante • Insel Tabarca

💳 ZAHLUNGSBEDINGUNGEN
Zur Bestätigung der Reservierung ist eine Anzahlung von 40 % des Gesamtpreises pro Person auf Konto HR7523400093207336956 erforderlich. Restzahlung spätestens 10 Tage vor Abreise. Bei Nichtzahlung des Restbetrags innerhalb der Frist behält sich der Veranstalter das Recht vor, die Reservierung zu stornieren.

HINWEIS: Der Tagesablauf kann bis 2 Wochen vor der Reise angepasst werden, bis die Termine für die jeweiligen Aktivitäten bestätigt sind.

📞 Reservierungen und Informationen
E-Mail: info@linatravelina.eu | Telefon: +385 91 214 4477

TraveLina – Reisen, die in Erinnerung bleiben!`;

export const ALICANTE_LISTOPAD_ES_DETAILED_INFO = `🌴 ALICANTE – ESCAPADA DE PRIMAVERA – SPRING ESCAPE
Escapada otoñal a la Costa Blanca – vino, mar y taller de paella

📅 1–4 octubre
🗓 4 días / 3 noches

Imagina una ciudad donde un paseo marítimo bordeado de palmeras conduce a playas doradas, un castillo histórico se eleva sobre los tejados y el aroma de una paella recién preparada impregna las callejuelas del casco antiguo.

Alicante, en la Costa Blanca, es una de las ciudades más soleadas de España. La ciudad combina rica historia, estilo de vida mediterráneo, playas preciosas y excelente gastronomía. Con mercados animados, barrios con encanto y ambiente relajado, Alicante es el destino perfecto para un viaje corto pero inolvidable.

🍂 ¿Por qué visitar Alicante en octubre?
El otoño temprano es el momento ideal para conocer esta ciudad mediterránea.
• Clima agradable – temperaturas de unos 20–24°C, perfectas para explorar la ciudad.
• Menos aglomeraciones que en verano – experiencia más relajada.
• Momento perfecto para gastronomía y rutas de vino.
• Ideal para paseos junto al mar, visitas turísticas y excursiones en barco.

El otoño en Alicante trae sol, aroma a mar y auténtica atmósfera española – una escapada ideal antes del invierno.

💰 PRECIO DEL PAQUETE FIRST MINUTE hasta el 1 de agosto de 2026
690,00 € por persona
(se necesitan mínimo 8 personas para realizar el viaje)

💰 PRECIO DEL PAQUETE LAST MINUTE desde el 1 de agosto de 2026
790,00 € por persona
(se necesitan mínimo 8 personas para realizar el viaje)

✅ EL PRECIO INCLUYE
• Vuelos matutinos directos Ryanair Zagreb–Alicante–Zagreb
• Equipaje de mano 40×20×25 cm incluido en el precio
• Alojamiento en apartamentos privados modernos cerca del centro
• Traslados aeropuerto – alojamiento – aeropuerto
• Taller de preparación de paella tradicional española
• Visita al castillo de Santa Bárbara con posible cata de vinos
• Paseo organizado por la ciudad y conocimiento de los principales lugares de interés

❌ EL PRECIO NO INCLUYE
• Equipaje de cabina – posibilidad de suplemento para maleta pequeña
• Seguro de viaje y de cancelación (disponible con suplemento)
• Actividades e excursiones adicionales no indicadas en el programa (p. ej. excursión en barco a Tabarca, museos, flamenco, etc.)
• Desayuno no incluido en el precio del apartamento; comidas por cuenta propia

📍 PROGRAMA DEL VIAJE

DÍA 1 – 1 octubre – Llegada a Alicante
Nos encontramos en el aeropuerto Franjo Tuđman. Vuelo matutino directo a Alicante. Traslado a apartamentos modernos cerca del centro. Por la tarde, presentación de la ciudad: Explanada de España, puerto y marina de Alicante, playa del Postiguet. Tiempo libre para cena y bares de tapas.

DÍA 2 – 2 octubre – Castillo, vino y cocina española
Desayuno de churros y chocolate caliente. Visita al castillo de Santa Bárbara – recorrido y posible cata de vinos locales. Por la tarde, taller de paella tradicional. Noche libre.

DÍA 3 – 3 octubre – Ritmo mediterráneo de la ciudad
Mercado Central, Calle de las Setas, Barrio Santa Cruz, MARQ (Museo Arqueológico de Alicante). Tarde libre para baño o paseo. Opcional: excursión en barco a la isla de Tabarca (con suplemento). Noche libre.

DÍA 4 – 4 octubre – Regreso a Zagreb
Traslado temprano al aeropuerto de Alicante. Vuelo matutino directo a Zagreb. Llegada a Zagreb a media mañana.

🏛 PRINCIPALES LUGARES DE INTERÉS DE ALICANTE
Castillo de Santa Bárbara • Explanada de España • Mercado Central • Barrio Santa Cruz • Calle de las Setas • Playa del Postiguet • Puerto de Alicante • Isla de Tabarca

💳 CONDICIONES DE PAGO
Para confirmar la reserva es necesario abonar un depósito del 40 % del precio total del paquete por persona en la cuenta HR7523400093207336956. El resto del importe como máximo 10 días antes de la salida. En caso de impago del resto en el plazo indicado, el organizador se reserva el derecho de cancelar la reserva.

NOTA: el programa diario puede modificarse hasta 2 semanas antes del viaje, hasta recibir los horarios de las actividades correspondientes.

📞 Reservas e información
Email: info@linatravelina.eu | Teléfono: +385 91 214 4477

TraveLina – ¡viajes que se recuerdan!`;

export const ALICANTE_LISTOPAD_TOUR_KEY = "alicante-listopad";

export function mergeAlicanteListopadIfMissing(tours, galleryPaths = []) {
  if (!Array.isArray(tours)) return tours;
  const key = ALICANTE_LISTOPAD_TOUR_KEY;
  const existing = tours.find((t) => t?.key === key);
  const detailedInfo = {
    hr: ALICANTE_LISTOPAD_HR_DETAILED_INFO,
    en: ALICANTE_LISTOPAD_EN_DETAILED_INFO,
    de: ALICANTE_LISTOPAD_DE_DETAILED_INFO,
    es: ALICANTE_LISTOPAD_ES_DETAILED_INFO,
  };

  if (existing) {
    return tours.map((tour) => {
      if (tour?.key !== key) return tour;
      return {
        ...tour,
        detailedInfo: { ...(tour.detailedInfo || {}), ...detailedInfo },
        image: tour.image || ALICANTE_COVER,
        gallery:
          Array.isArray(tour.gallery) && tour.gallery.length > 0
            ? tour.gallery
            : galleryPaths.length > 0
              ? galleryPaths
              : [ALICANTE_COVER],
      };
    });
  }

  const template =
    tours.find((t) => t?.key === "alicante-maj") ||
    tours.find((t) => t?.key === "alicante") ||
    tours[0];
  if (!template) return tours;

  const nextId = Math.max(0, ...tours.map((t) => Number(t?.id) || 0)) + 1;
  const newTour = {
    ...template,
    id: nextId,
    key,
    category: "beach",
    days: 4,
    nights: 3,
    country: "Spain",
    date: "2026-10-01",
    price: 690,
    tag: "New",
    image: ALICANTE_COVER,
    blogText: { hr: "", en: "", de: "", es: "" },
    gallery: galleryPaths.length > 0 ? [...galleryPaths] : [ALICANTE_COVER],
    detailedInfo,
  };
  return [...tours, newTour];
}
